// extracted by mini-css-extract-plugin
module.exports = {"head":"head--29qEE"};